import React from 'react'

interface HomePageViewProps {}

const HomePageView: React.FC<HomePageViewProps> = () => {
  return <span>HomePage</span>
}

export default HomePageView
